import {useCallback, useState} from "react";
import {useStore} from "react-redux";

import {useAppSelector} from "../../store/hooks";
import {IRootState} from "../../store/store";

export const useRegistrationFlowRun = () => {
    const store = useStore<IRootState>();
    const [runId, setRunId] = useState<number | null>(null);
    const isRunActive = useAppSelector((state) => runId !== null && state.registrationFlow.isActive && state.registrationFlow.runId === runId);

    const rememberStartedRun = useCallback(() => setRunId(store.getState().registrationFlow.runId), [store]);
    const forgetRun = useCallback(() => setRunId(null), []);

    return {
        isRunActive,
        hasRunFinished: runId !== null && !isRunActive,
        rememberStartedRun,
        forgetRun
    };
};
import {useCallback, useState} from "react";
import {useStore} from "react-redux";

import {useAppSelector} from "../../store/hooks";
import {IRootState} from "../../store/store";

export const useRegistrationFlowRun = () => {
    const store = useStore<IRootState>();
    const [runId, setRunId] = useState<number | null>(null);
    const isRunActive = useAppSelector((state) => runId !== null && state.registrationFlow.isActive && state.registrationFlow.runId === runId);

    const rememberStartedRun = useCallback(() => setRunId(store.getState().registrationFlow.runId), [store]);
    const forgetRun = useCallback(() => setRunId(null), []);

    return {
        isRunActive,
        hasRunFinished: runId !== null && !isRunActive,
        rememberStartedRun,
        forgetRun
    };
};
